// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"247e2e4b","455":"b09b70f1","977":"a1d48d9f"}[chunkId] + ".chunk.js";
};